// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
export interface RefGeneListData {
  gene_id: string;
  chr: string;
  pn: string;
  start: number;
  end: number;
  gene_type: string;
  gene_name: string;
  svs: number[];
}

type CellValue = string | number | number[] | null | undefined;

export type ColumnDef<T> = {
  [K in keyof T]: {
    header: string;
    cell: (row: T) => CellValue;
  }
};

export function makeColumns<T>() {
  return <C extends ColumnDef<T>>(c: C) => c;
}
